import { useTranslation } from "react-i18next";
import { EmptyState } from "src/grading/components";
import { useListDistrictsQuery } from "src/store/reducers/districts/districtsApiSlice";
import StaffTab from "./StaffTab";
import { usePeopleUrlState } from "./usePeopleUrlState";

const DISTRICT_ADMIN_ROLES = ["district_admin" as const];

/** Platform admins: the chosen district's district admins, with "Invite district admin". */
export const DistrictAdminsTab = () => {
  const { t } = useTranslation();
  const url = usePeopleUrlState();
  const { data: districts } = useListDistrictsQuery(undefined, {
    skip: !url.district,
  });

  if (!url.district) {
    return (
      <EmptyState
        title={t("people.chooseDistrictTitle")}
        body={t("people.chooseDistrictBody")}
      />
    );
  }

  return (
    <StaffTab
      roles={DISTRICT_ADMIN_ROLES}
      inviteRole="district_admin"
      inviteLabel={t("staff.inviteDistrictAdmin")}
      tableLabel={t("people.tabs.district-admins")}
      emptyTitle={t("staff.noDistrictAdminsTitle")}
      emptyBody={t("staff.noDistrictAdminsBody")}
      districtName={districts?.find((d) => d.id === url.district)?.name}
    />
  );
};

export default DistrictAdminsTab;
